/*---------------------------
| actionTypes
---------------------------*/
export const actionTypes = {
    MODAL2_IS_VISIBLE_UPDATE: "MODAL2: isVisibleUpdate"
};
